function showSubContent (btn) {
    var ev;
    var init = function(){
        if ( !APP.objects.SubContent ) {
            requestAnimationFrame(init);
        }
        else {
            var param = JSON.parse(btn.getAttribute('data-param'));
            APP.objects.SubContent.show(btn, ev, param.name, param.targetUid);
        }
    };

    //
    btn.onclick = function(e){
        ev = e;
        init();
        return false;
    }
}

export {showSubContent};